import { useCallback } from 'react';
import * as Store from '@apply/store';
import { Question, QuestionType, PageQuestionProps } from '@apply/ui';
import { connect } from 'react-redux';
import { LoanType } from '@apply/constants';

interface StructureTypePageQuestionProps extends PageQuestionProps {
    loanType: LoanType;
    onChangeStructureType: (
        guid: string,
        value: Store.PropertiesStore.Types.NonRentalStructureType | Store.PropertiesStore.Types.RentalStructureType,
        loanType: LoanType
    ) => void;
}

const StructureType: React.FC<StructureTypePageQuestionProps> = ({
    onQuestionValidate,
    submitted,
    property,
    loanType,
    onChangeStructureType,
    required,
}) => {
    const nonRentalStructureTypeValues = [
        { display: '', value: '' },
        ...Store.PropertiesStore.Types.nonRentalStructureTypes.map((st) => {
            return {
                display: st.toString(),
                value: st.toString(),
            };
        }),
    ];

    const handleNonRentalStructureType = useCallback(
        (newvalue) =>
            onChangeStructureType(property.guid, newvalue as Store.PropertiesStore.Types.NonRentalStructureType, loanType),
        [property?.guid, loanType, onChangeStructureType]
    );

    return (
        <div className='form-group'>
            <Question
                type={QuestionType.RowSelector}
                submitted={submitted}
                selector='structureType'
                styleName='ungrouped'
                onQuestionValidate={onQuestionValidate}
                values={nonRentalStructureTypeValues}
                value={property.structureType}
                onChange={handleNonRentalStructureType}
                required={required}
            >
                Structure Type
            </Question>
        </div>
    );
};

export const mapStateToProps = (state: Store.ApplyRootStateType) => {
    return {
        property: state.properties.items.find((itm) => itm.guid === state.properties.currentPropertyId),
        loanType: state.borrower.loanType,
    };
};

export const mapDispatchToProps = (dispatch: Store.ApplyDispatchType) => {
    const props: {
        onChangeStructureType: (
            guid: string,
            value: Store.PropertiesStore.Types.NonRentalStructureType | Store.PropertiesStore.Types.RentalStructureType,
            loanType: LoanType
        ) => void;
        dispatch: Store.ApplyDispatchType;
    } = {
        onChangeStructureType: (
            guid: string,
            value: Store.PropertiesStore.Types.NonRentalStructureType | Store.PropertiesStore.Types.RentalStructureType,
            loanType: LoanType
        ) => dispatch(Store.PropertiesStore.Actions.updateStructureType(guid, value, loanType)),
        dispatch,
    };
    return props;
};

export default connect(mapStateToProps, mapDispatchToProps)(StructureType);
